import { combineValidators, composeValidators, isRequired } from 'revalidate';

import { isValidEmail, isValidPassword, isValidFullname } from 'utils/validators';

export default combineValidators({
  email: composeValidators(isValidEmail, isRequired)('Email'),
  fullname: composeValidators(isValidFullname, isRequired)('Fullname'),
  password: composeValidators(isValidPassword, isRequired)('Password'),
});
